import { Language } from './language';

export class TranslationKeyDto {
    public TranslationKeyId:string;

    public Name:string;

    public Description:string;

    public TranslationCategoryId:number;

    public TranslationCategoryName:string;

    public TranslationCategoryIsPage:boolean;

    public EnglishTranslatedValue:string;

    public SortOrder:number;

    public TranslationCount:number;

    public MissingTranslationLanguageList:Language[];

    public MissingTranslationLanguages:string[];

    constructor(TranslationKeyId:string = "", Name:string = ""){
        this.TranslationKeyId = TranslationKeyId;
        this.Name = Name;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/translation-key-dto.ts